/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatParticipant {
    getFixupPrototypeFunction() { return AgentChatParticipant.fixupPrototype; }

    static newInstance(model: Partial<AgentChatParticipant>): AgentChatParticipant {
        let obj = Object.assign(new AgentChatParticipant(), model);
        AgentChatParticipant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatParticipant>): AgentChatParticipant {
        if (!model) return null;
        return AgentChatParticipant.newInstance(<AgentChatParticipant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatParticipant) {
        if (!obj) return;

        models.AgentChatParticipant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatParticipant): boolean {
        Object.setPrototypeOf(obj, AgentChatParticipant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the user
     */
    user_id: string;

    /**
     * Name of the user
     */
    name: string;

    /**
     * Email of the user
     */
    email: string;

    /**
     * Indicates if the user is the owner of the chat
     */
    is_owner: boolean = false;

}
